import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Events, AlertController } from 'ionic-angular';

@Component({
  selector: 'render-multiple-data-cell',
  templateUrl: 'render-multiple-data-cell.html'
})
export class RenderMultipleDataCellComponent implements ICellRendererAngularComp {
  cellValue: any;
  label: string;
  showPlay: boolean = true;
  showPreview: boolean = false;
  constructor() {
  }

  agInit(params: any): void {
    this.cellValue = params;
    this.label = params.value || null;

  }

  refresh(params?: any): boolean {
    this.cellValue = params;
    return true;
  }

  onClick(e,flag) {
   
    if (this.cellValue.onClick instanceof Function) {
    
      const params = {
        event: e,
        flag:flag,
        rowData: this.cellValue.node.data,
        type: 'update',
        rowIndex: this.cellValue.rowIndex
       
      }
      this.cellValue.onClick(params);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/agGridRenderer/render-multiple-data-cell/render-multiple-data-cell.ts